// Module
var code = "<svg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.713 17.713a6.275 6.275 0 11-8.875-8.875 6.275 6.275 0 118.875 8.875z\" stroke-width=\"1.5\"/><path d=\"M21 21l-3.287-3.286\" stroke-width=\"1.5\" stroke-linecap=\"round\"/></svg> ";
// Exports
module.exports = code;